import React from 'react';

const Footer = () => (
  <footer className="bg-green-600 text-white py-2 text-center">
	<p>&copy; 2025 Avia Avraham</p>
  </footer>
);

export default Footer;